import { useRef, useEffect } from 'react';
import { useSearchParams, useRouter } from 'next/navigation';
import toast from 'react-hot-toast';
import { useFormat } from 'helpers/hooks/useFormat';
import { Account } from 'types/entity/account';
import LoginForm from './login-form';
import AlterForm from '../../account/account-atoms/alter-form';

export interface LoginProps {
  login?: (email: string, password: string, rememberMe?: boolean) => Promise<Account>;
  requestConfirmationEmail?: (email: string, password: string) => Promise<{ error?: boolean; message?: string }>;
  requestPasswordReset?: (email: string) => Promise<{ error?: boolean; message?: string }>;
}

const Login: React.FC<LoginProps> = ({ login, requestConfirmationEmail, requestPasswordReset }) => {
  const router = useRouter();

  const { formatMessage } = useFormat({ name: 'gruenland' });

  const searchParams = useSearchParams();

  const verify = searchParams.get('verify');

  const responded = useRef(false);

  useEffect(() => {
    if (!verify || responded.current) return;

    if (verify === '0')
      toast.error(formatMessage({ id: 'feedback.emailVerificationFailed', defaultMessage: 'Verifica email fallita.' }));
    else
      toast.success(formatMessage({ id: 'feedback.emailVerified', defaultMessage: 'Email verificata con successo.' }));

    responded.current = true;
  }, [verify, router, formatMessage]);

  return (
    <>
      <div className="m-auto grid max-w-screen-sm px-4">
        <LoginForm
          login={login}
          requestConfirmationEmail={requestConfirmationEmail}
          requestPasswordReset={requestPasswordReset}
        />
      </div>
      <AlterForm page="register" />
    </>
  );
};

export default Login;
